import { createRoot } from 'react-dom/client'

import App from './App.tsx'
import './index.css'
import '@iws/theme-builder/dist/theme-builder.css'

createRoot(document.getElementById('root')!).render(<App />)
